export default __webpack_public_path__ + "static/media/I.acb76365.svg";